// 查询权限须与后端 services/permissions/researchTaskScope.js 保持一致。

export const EDUCATIONAL_RESEARCH_TASKS_ROUTE = 'educationalResearchTasks';

export const RESEARCH_TASK_QUERY_PERMISSIONS = {
  management: 'query-research-task-management',
  videoReview: 'query-video-review',
  firstLesson: 'query-first-lesson',
  teacherGrade: 'query-teacher-grade',
  firstLessonCommunication: 'query-first-lesson-communication',
};

export const VIDEO_REVIEW_OPERATION_PERMISSIONS = {
  transfer: { route: EDUCATIONAL_RESEARCH_TASKS_ROUTE, function: 'transfer-video-review', scope: 'all' },
  cancel: { route: EDUCATIONAL_RESEARCH_TASKS_ROUTE, function: 'cancel-video-review', scope: 'all' },
};

export function getResearchTaskScope(hasPermission, type) {
  const action = RESEARCH_TASK_QUERY_PERMISSIONS[type];
  if (!action) return null;
  const permission = { route: EDUCATIONAL_RESEARCH_TASKS_ROUTE, function: action };
  if (hasPermission?.({ ...permission, scope: 'all' })) return 'all';
  if (hasPermission?.({ ...permission, scope: 'partial' })) return 'partial';
  return null;
}

export const VIEW_VIDEO_REVIEW_PERMISSION = RESEARCH_TASK_QUERY_PERMISSIONS.videoReview;
export const VIEW_TEACHER_GRADE_PERMISSION = RESEARCH_TASK_QUERY_PERMISSIONS.teacherGrade;
export const VIEW_PARTTIME_RESEARCH_HOURS_PERMISSION = 'view-parttime-working-hours';

// 「非全职老师教研工时」页按类型汇总的列（视频审核 + 教师评级）
export const RESEARCH_HOURS_CATEGORIES = ['抽查视频审核', '教师评级'];
